import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function IsDateHeadersDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled == getIsBitSet(2 /* DateHeadersDisabled */));
});
//# sourceMappingURL=isDateHeadersOptionDirty.js.map